module.exports = __webpack_public_path__ + "media/images/flags/16/Bahrain-8bb14529d862e8eb534f6b28a5116f31.png";